import { render, staticRenderFns } from "./PersonalDataProcessingPolicy.vue?vue&type=template&id=229b591c&scoped=true&"
import script from "./PersonalDataProcessingPolicy.vue?vue&type=script&lang=js&"
export * from "./PersonalDataProcessingPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDataProcessingPolicy.vue?vue&type=style&index=0&id=229b591c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b591c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VIcon,VRow,VSpacer})
